import { socialTwitter } from 'react-icons-kit/ionicons/socialTwitter';
import { socialFacebook } from 'react-icons-kit/ionicons/socialFacebook';
import { socialGithub } from 'react-icons-kit/ionicons/socialGithub';

export const SOCIAL_PROFILES = [
  {
    id: '1',
    icon: socialFacebook,
    url: '#',
  },
  {
    id: '2',
    icon: socialTwitter,
    url: '#',
  },
  {
    id: '3',
    icon: socialGithub,
    url: '#',
  },
];
